import { OrganisationFormat, stripEmptyFromObject } from '@one-tree/library'
import styled from 'styled-components'
import {
  OrgStatus,
  PartialAdminOrg,
  PaymentMethod,
  PaymentProvider,
} from '../../types/orgTypes'

export const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 50px;
  h3 {
    margin: 35px 0 0;
  }
`
export const Column = styled.div`
  display: grid;
  grid-row-gap: 25px;
  grid-auto-rows: min-content;
`

export const HERO_DIMENSIONS = { x: 1200, y: 400 }
export const LOGO_DIMENSIONS = { x: 200, y: 200 }

export const heroSubtitleText = 'The hero image appears at the top of the page, under the logo. It should be 1200px by 400px.'
export const faviconText = 'The favicon should be a ".ico" file, at least 16px by 16px.'
export const logoText = 'The logo should be at least 200px on the smallest side.'
export const cssText = 'Use CSS to change elements of the page\'s styling, e.g. text colour or font.'

export type IEditOrgProps = {
  organisation: PartialAdminOrg
  change: (updates: PartialAdminOrg) => void
  stripeHasChanged?: boolean
  handleStripeWebhook?: () => Promise<void>
}

export const productMap = new Map<OrganisationFormat, string>([
  [OrganisationFormat.GiftVouchers, 'Gift vouchers'],
  [OrganisationFormat.SpecialOffers, 'Special offers'],
  [OrganisationFormat.Tickets, 'Tickets'],
])

export const statusMap = new Map<OrgStatus, string>([
  [OrgStatus.Active, 'Active'],
  [OrgStatus.Suspended, 'Suspended'],
  [OrgStatus.Cancelled, 'Cancelled'],
  [OrgStatus.Draft, 'Draft'],
])

export const paymentMap = new Map<PaymentMethod, string>([
  [PaymentMethod.Manual, 'Manual'],
  [PaymentMethod.GoCardless, 'GoCardless'],
])

export const stripUnnecessary = (
  updates: PartialAdminOrg,
  paymentProvider: PaymentProvider | false,
): PartialAdminOrg => {
  if (paymentProvider === PaymentProvider.Stripe) {
    const updated = { ...updates }
    delete updated.stripeWebhookSecret // Own webhook can't be updated from front end
    delete updated.paypalClientId
    delete updated.paypalSecret
    delete updated.paypalWebhookId
    delete updated.trustPassword
    delete updated.trustId
    return stripEmptyFromObject(updated)
  }
  if (paymentProvider === PaymentProvider.PayPal) {
    const updated = { ...updates }
    delete updated.paypalWebhookId // Own webhook can't be updated from front end
    delete updated.stripePublicKey
    delete updated.stripeSecretKey
    delete updated.stripeWebhookSecret
    delete updated.trustPassword
    delete updated.trustId
    return stripEmptyFromObject(updated)
  }
  if (paymentProvider === PaymentProvider.Trust) {
    const updated = { ...updates }
    delete updated.stripePublicKey
    delete updated.stripeSecretKey
    delete updated.stripeWebhookSecret
    delete updated.paypalClientId
    delete updated.paypalSecret
    delete updated.paypalWebhookId
    return stripEmptyFromObject(updated)
  }
  return updates
}
